import React from "react";
import { Header, List, Message, Segment } from "semantic-ui-react";
import CustomJsonView from "../../custom-json-view";

const updateJson = {
  pids: {
    doi: {
      identifier: "10.83356/z7yq-nv30",
      provider: "datacite",
    },
  },
  metadata: {
    titles: [
      {
        titleLanguage: "eng",
        titleText: "This is test title",
      },
    ],
  },
};

const Update = () => {
  return (
    <Segment padded>
      <Header as="h2" dividing>
        Update existing draft record
      </Header>
      <Message info>
        <Message.Header>Overview</Message.Header>
        <p>
          This endpoint allows you to change / edit an existing draft record. It
          will change the record to the given state (body of the request).
        </p>
        <p>
          For the editing of the record, you must have the specified
          permissions.
        </p>
      </Message>
      <Header as="h3">Request Details</Header>
      <Segment>
        <Header as="h4">Body Parameters</Header>
        <List bulleted>
          <List.Item>
            <strong>metadata</strong> - New state of the metadata values of the
            record.
          </List.Item>
          <List.Item>
            (External datasets) <strong>pids</strong> - New pids values of the
            record.
          </List.Item>
        </List>
      </Segment>
      <Segment>
        <Header as="h4">Endpoint - Update EXTERNAL DATASETS</Header>
        <p> External datasets can be updated only by system administrators.</p>
        <Message>
          <Message.Content>
            <strong>PUT</strong> /api/external-datasets/ID <br />
            <strong>Headers:</strong> <br />
            Content-Type: application/json <br />
            Authorization: Bearer &lt;authToken&gt;
          </Message.Content>
        </Message>
      </Segment>
      <Segment>
        <Header as="h4">Endpoint - Update DATASETS</Header>
        <p>
          Datasets can be updated only by system record owners or community
          owners.
        </p>
        <Message>
          <Message.Content>
            <strong>PUT</strong> /api/datasets/ID/draft <br />
            <strong>Headers:</strong> <br />
            Content-Type: application/json <br />
            Authorization: Bearer &lt;authToken&gt;
          </Message.Content>
        </Message>
      </Segment>
      <Header as="h3">Example Request Body</Header>
      <CustomJsonView src={updateJson} />
      <Header as="h3">Response</Header>
      <Message warning>
        <Message.Header>TODO</Message.Header>
        <p>Response details will be added here.</p>
      </Message>
    </Segment>
  );
};

export default Update;
